<template>
  <div
    :class="[
      $style.base,
      {
        [$style.smallScreen]: $screen === 's'
      }
    ]"
  >
    <div :class="$style.section">
      <slot name="left" />
    </div>
    <div :class="$style.section">
      <slot name="right" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  inheritAttrs: false,
});
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: $spacing;
  width: 100%;

  &.smallScreen {
    flex-direction: column;
    align-items: stretch;
  }
}

.section {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: $spacing;

  .base.smallScreen & {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
